/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Whatsappnotification1Inputs */

const en__field_whatsappnotification1 = /** @type {(inputs: _Field_Whatsappnotification1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatsapp Notification`)
};

const de__field_whatsappnotification1 = /** @type {(inputs: _Field_Whatsappnotification1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatsapp Benachrichtigung`)
};

/**
* | output |
* | --- |
* | "Whatsapp Notification" |
*
* @param {_Field_Whatsappnotification1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_whatsappnotification1 = /** @type {((inputs?: _Field_Whatsappnotification1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Whatsappnotification1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_whatsappnotification1(inputs)
	return de__field_whatsappnotification1(inputs)
});
export { _field_whatsappnotification1 as "_field_whatsappNotification" }